export interface IAuthConfig {
    authority: string;
    clientId: string;
    knownAuthorities: string[];
    uri: string;
    scopes: string[];
}

export class AuthConfig {
    private static _authConfig: IAuthConfig = {
        clientId: '',
        authority: '',
        knownAuthorities: [],
        uri: '',
        scopes: [],
    };
    static get config(): IAuthConfig {
        return this._authConfig;
    }
    static setConfig(auth: IAuthConfig) {
        this._authConfig = { 
            ...this._authConfig,
            ...auth 
        };
    }
    static get uri(): string {
        return this._authConfig.uri;
    }
}
